import React from 'react';

export const Minus = React.memo(({ fill }) => (
  <>
    <line id='svg_1' y2='15' x2='24' y1='15' x1='6' stroke={fill} fill='none' />
  </>
));
Minus.displayName = 'Minus';
